import { IBaseDataParser } from "./IBaseDataParser";

/*
    *Parser that saves parsed information and returns it on parse invocation
    *To be used for parsers that receive data for several stages of the game at the same time
    *For exapmple free spin games received in one request or bonus game with multiple stages received in one request etc
    *If new data is reveived old one will be overriten
*/
export default abstract class  AbstractBulkDataParser<T> implements IBaseDataParser<T>  {
    protected processedData: T[];

     //DO NOT OVERRIDE
    public check(data: any): boolean {
        if (!data) {
            return this.hasProcessedData();
        }

        return this.validateData(data);
    }

    protected abstract validateData(data):boolean;


    //DO NOT OVERRIDE
    public parse(data: any): T[] | T {
        if (!data) {
            return this.recoverProcessedData();
        } else  {
            let result = this.processData(data);
            if (Array.isArray(result)) {
                this.saveProcessedData(result);
                return this.recoverProcessedData();
            }
            return result;
        }
    }

    protected abstract processData(data): T[] | T;

    protected saveProcessedData(data: T[]) {
        this.processedData = data;
    }

    protected recoverProcessedData(): T {
        return this.processedData.shift();
    }

    protected hasProcessedData(): boolean {
        return this.processedData && this.processedData.length > 0;
    }
}